// ContextoService.js
import http from "./Http";


// Genera el contexto (crea el documento en el servidor)
const GenerarContexto = async (file = null) => {
  try {
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
    }

    const response = await http.post(`/sac/prompt0-genDoc`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Error en ContextoService (GenerarContexto):", error);
    throw error;
  }
};


// Descarga el documento previo SAC en el formato indicado
const DescargarContexto = async (formato = "pdf") => {
  try {
    const response = await http.get(`/descargar/doc-previo-sac?formato=${formato}`, {
      responseType: "blob", // 🔹 Necesario para archivos binarios
    });
    return response;
  } catch (error) {
    console.error("Error en ContextoService (DescargarContexto):", error);
    throw error;
  }
};

const existeContextoGenerado = async () => {
  try {
    await http.get("/descargar/doc-previo-sac?formato=md", {
      responseType: "text",
    });
    return true;
  } catch (error) {
    if (error?.response?.status === 404) {
      return false;
    }
    console.error("Error en ContextoService (existeContextoGenerado):", error);
    throw error;
  }
};

const ContextoService= {
  GenerarContexto,
  DescargarContexto,
  existeContextoGenerado,
};

export default ContextoService
